import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Popover, notification, Button, Tooltip } from "antd";
import {
    InfoCircleOutlined,
    ReloadOutlined,
} from "@ant-design/icons";

import { formatDateTime } from "../../helpers/date";

import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";

import { KYCStatusTag } from '../shared/payoutTag'

const updateBeneficiary = (params) => {

    axios.post(`/api/payout/beneficiaries`, null, {
        params: { merchantId: params }
    })
        .then(() => console.log("Success"))
        .catch(err => {
            notification.error({
                message: "Error when downloading Payout Report",
                description: err.response?.data.message || err.message,
            });
        });
};

const BeneficiaryList = (props) => {
    const { permissions } = usePermissions();

    const [payouts, setPayouts] = useState(props.payouts);
    const [selectedRows, setSelectedRows] = useState(props.selectedRows);

    useEffect(() => {
        setPayouts(props.payouts);
    }, [props.payouts]);

    const table = [
        {
            title: "User Id",
            dataIndex: ["userId"],
            width: 120,
            ellipsis: true,
        },
        {
            title: "GUID",
            dataIndex: "beneficiary",
            width: 110,
            render: (_, record) => {

                return <span>{record.beneficiary.guid || record.beneficiary.id}</span>;
            },
        },
        {
            title: "Beneficiary Created Date",
            dataIndex: ["beneficiary", "createdDate"],
            width: 150,
            render: (createdAt) => formatDateTime(createdAt),
        },
        {
            title: "Beneficiary Merchant",
            dataIndex: ["beneficiary"],  // just beneficiary object
            width: 150,
            render: (_, record) => {
                const beneficiary = record.beneficiary || {};
                const bankName = beneficiary.bankName || beneficiary.bankId || "-";

                const email = beneficiary.beneficiaryEmail || "";
                const phone = beneficiary.beneficiaryMobileId || "";
                const accountNo = beneficiary.bankAccountNumber || "";
                const accName = beneficiary.bankAccountName || "";

                const bankDetails = (
                    <p>
                        <strong>Bank</strong>: {bankName} <br />
                        <strong>Bank Account</strong>: {accountNo} <br />
                        <strong>Account Name</strong>: {accName} <br />
                        <strong>Phone Number</strong>: {phone || "-"} <br />
                        <strong>Email</strong>: {email || "-"} <br />
                        <strong>Doc Type</strong>: {beneficiary.beneficiaryIDType || "-"} <br />
                        <strong>BRN</strong>: {beneficiary.beneficiaryID || "-"} <br />

                    </p>
                );

                return (
                    <>
                        {record.countryCode || ""}{record.phone || ""} ({record.email})
                        <Popover content={bankDetails}>
                            <InfoCircleOutlined />
                        </Popover>
                    </>
                );
            },
        }, {
            title: "Status",
            dataIndex: ["beneficiary", "kycStatusId"],
            width: 150,
            render: (kycStatusId) => <p>{<KYCStatusTag statusKey={kycStatusId} />}</p>,
        },
        ...(permissions?.includes(PERMISSIONS.UPDATE_BENEFICIARY_STATUS)
            ? [
                {
                    title: "Action",
                    dataIndex: "userId",
                    width: 100,
                    render: (_, record) => {

                        if (record.beneficiary.isSuccess) return
                        return (
                            <Tooltip title="Update KYC Status">
                                <Button onClick={() => updateBeneficiary(record.merchant.merchantId)}>
                                    <ReloadOutlined />
                                </Button>
                            </Tooltip>
                        );

                    },
                },
            ]
            : []),
    ];

    return (
        <div className="table">
            <Table
                rowSelection={{ selectedRows, onChange: props.onSelectRows }}
                rowKey="userId"
                className="table-section"
                columns={table}
                dataSource={payouts}
                pagination={false}
                scroll={{ x: 1800, y: 600 }}
                loading={props.loading}
            />
        </div>
    );
};

export default BeneficiaryList;
